import MBadge from './MBadge.vue';

MBadge.install = (app) => {
  app.component('MBadge', MBadge);
};

export { MBadge };
